import { type PositionInput, useChatWidgetPositionStore } from './store';

const useChatWidget = () => {
  const isFooterVisible = useChatWidgetPositionStore((s) => s.isFooterVisible);
  const setStorePosition = useChatWidgetPositionStore((s) => s.setPosition);

  const setPosition = (position: PositionInput) => {
    setStorePosition(position);
  };

  const hide = (hideIt: boolean) => {
    // Intercom's default launcher stays hidden always — the AIChatFloatingButton FAB
    // is the only entry point. We only collapse the messenger panel when hiding.
    if (hideIt) window.Intercom?.('hide');
  };

  const openIntercom = () => {
    window.Intercom?.('show');
  };

  const closeIntercom = () => {
    window.Intercom?.('hide');
  };

  const sendIntercomMessage = (message: string) => {
    window.Intercom?.('showNewMessage', message);
  };

  return {
    setPosition,
    hide,
    openIntercom,
    closeIntercom,
    sendIntercomMessage,
    isFooterVisible,
  };
};

export default useChatWidget;
